import { Routes } from '@angular/router';
import { SigninCanActivateGuard } from '@app/core/guards/signin.can-activate.guard';
import { DeviceDetectorService } from 'ngx-device-detector';

export function routesFactory(deviceDetector: DeviceDetectorService): Routes {
    return [
        {
            path: '',
            loadChildren: () => {
                return deviceDetector.isMobile() ?
                    import('@app/client/uploader/mobile/uploader-mobile.module').then(m => m.UploaderMobileModule) :
                    import('@app/client/uploader/desktop/uploader.module').then(m => m.UploaderModule);
            }
        },
        {
            path: 'signin',
            canActivate: [SigninCanActivateGuard],
            loadChildren: () => {
                return deviceDetector.isMobile() ?
                    import('@app/client/signin/mobile/signin-mobile.module').then(m => m.SigninMobileModule) :
                    import('@app/client/signin/desktop/signin.module').then(m => m.SigninModule);
            }
        },
        {
            path: 'signup',
            loadChildren: () => import('@app/client/signup/signup.module').then(m => m.SignupModule),
        },
    ];
}